<!-- 工作台 -->
<template>
    <div id class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">订单号</div>
                <el-input
                    style="width: 250px"
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.OrderCode"
                    v-filter-special-char="searchData.OrderCode"
                    placeholder="请输入订单号"
                ></el-input>
                <div class="search-name">下单时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn re-back-order">
            <div class="div-table-row re-back-order-title">
                <div class="div-table-cell" style="width: 20%">订单编号</div>
                <div class="div-table-cell" style="width: 40%">订单商品</div>
                <div class="div-table-cell" style="width: 10%">联系客服</div>
                <div class="div-table-cell" style="width: 20%">下单时间</div>
                <div class="div-table-cell" style="width: 10%">整单申请</div>
            </div>
            <div v-if="tableDataLength != 0">
                <div class="re-back-order-main">
                    <div :key="index" class="div-table-row" v-for="(item, index) in tableData">
                        <div class="div-table-cell" style="width: 20%">{{ item.OrderCode }}</div>
                        <div class="div-table-cell goods-ctn" style="width: 40%">
                            <div :key="index2" class="goods-item" v-for="(i, index2) in item.DetailList">
                                <el-tooltip :content="i.Name" placement="top">
                                    <div class="image-ctn goods-cover">
                                        <img :src="downloadUrl + i.ShowImg" :onerror="defaultImg" />
                                    </div>
                                </el-tooltip>
                                <p class="apply-btn" @click="gotoApplyDetails(item, i.OrderGoodRId)" v-if="permission.edit">申请</p>
                            </div>
                        </div>
                        <div class="div-table-cell goto-server" style="width: 10%" @click="askOrder(item)" v-if="permission.contact">
                            <img src="../../../assets/images/kf-head.png" />
                            <div>{{ permission.contact }}</div>
                        </div>
                        <div class="div-table-cell" style="width: 20%">{{ item.CreateTime }}</div>
                        <div class="div-table-cell zd-apply" style="width: 10%">
                            <span @click="gotoApplyDetails(item)" v-if="permission.applyAll">{{ permission.applyAll }}</span>
                        </div>
                    </div>
                </div>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableDataLength"
                    ></el-pagination>
                </div>
            </div>
            <div class="no-data" v-else>暂无数据</div>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.BeginDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        timePicker,
        breadcrumb
    },
    data() {
        return {
            timeVisible: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            searchData: {
                UserId: this.$util.getLocalStorage('userMsg').EmployeeId,
                OrderCode: '',
                BeginDate: '',
                EndDate: '',
                page: 1,
                limit: 15,
                key: ''
            },
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('AfterSale');
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.BeginDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                UserId: this.searchData.UserId,
                OrderCode: '',
                BeginDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize,
                key: ''
            };
        },
        askOrder(item) {
            if (this.$store.state.connectState != 2) {
                this.$util.warningMsg('请先连接到客服再进行询问');
                return;
            }
            this.$store.commit('updateAskOrder', item);
        },
        gotoApplyDetails(item, OrderGoodRId) {
            if (!item.DetailList) {
                this.$util.warningMsg('该订单没有可申请售后的商品');
                return;
            }
            this.$router.push(
                `./afterApplyDetails?OrderType=${item.OrderType}&OrderId=${item.OrderId}&OrderCode=${item.OrderCode}&OrderGoodRId=${OrderGoodRId ? OrderGoodRId : ''}`
            );
        },
        back() {
            window.history.back(-1);
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: `/api/MallSaleOrder/GetAfterSaleSaleOrderList`,
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.goods-cover {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        max-width: 50px;
        max-height: 50px;
    }
}
.zd-apply {
    color: @theme;
    cursor: pointer;
}
.goto-server {
    color: @theme;
    cursor: pointer;
    img {
        width: 25px;
        height: 25px;
    }
}
.re-back-order-main {
    .div-table-cell {
        padding-left: 10px;
        line-height: 60px;
        display: flex;
        align-items: center;
    }
}
.goods-ctn {
    display: flex;
    flex-wrap: wrap;
    .goods-item {
        width: 70px;
        padding: 10px;
        text-align: center;
    }
    .apply-btn {
        color: @theme;
        cursor: pointer;
        line-height: 1.5em;
    }
}
.re-back-order-title {
    background: @border3Color;
    text-align: center;
    line-height: 36px;
}
.bread-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
